import { render, staticRenderFns } from "./GeotagCard.vue?vue&type=template&id=6868c8dc&"
import script from "./GeotagCard.vue?vue&type=script&lang=js&"
export * from "./GeotagCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports